export const landing = {
  root: {
    name: 'Landing Page home',
    title: 'header.home',
    path: '/landing-page',
    meta: {
      requiresAuth: false,
      hideSideBar: true,

      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Home`,
      isHiddenRoute:
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '7' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '10' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '17' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '18',
    },
  },
  leaderShipDevelopment: {
    name: 'LeaderShip Development',
    path: '/landing-page/leadership-development',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | LeaderShip Development`,
      isHiddenRoute:
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '17' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '7',
    },
  },
  executiveCoach: {
    name: 'Executive Coach',
    path: '/executive-coach',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Executive Coach`,
      isHiddenRoute:
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '17' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '7',
    },
  },
  professional: {
    name: 'Professional',
    path: '/professional-leadership',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Professional LeaderShip`,
    },
  },
  webinars: {
    path: '/webinars',
    name: 'Webinars',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Webinars`,
      isHiddenRoute:
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '17' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '7',
    },
  },
  about: {
    name: 'About',
    title: 'header.about',
    path: '/about-us',
    icon: 'mdi-information',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | About`,
      isHiddenRoute:
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '7' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '10' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '17' ||
        import.meta.env.VITE_CLIENT_ORGANIZATION_ID === '18',
    },
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    title: 'header.privacyPolicy',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Privacy Policy`,
    },
  },
  refundPolicy: {
    name: 'Refund Policy',
    path: '/refund-policy',
    title: 'header.refundPolicy',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Refund Policy`,
    },
  },
  usefulLink: {
    name: 'usefulLink',
    path: '/pages/:slug',
    title: 'header.usefulLink',
    pathFn: (slug: string) => `/pages/${slug}`,
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Useful Link`,
      shouldDynamicPageEnabled: true,
    },
  },

  educationEthics: {
    name: 'Education Ethics',
    path: '/education-ethics',
    title: 'header.educationEthics',

    icon: 'mdi-email',

    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Education Ethics`,
    },
  },
  termsOfUse: {
    name: 'Terms of Use',
    path: '/terms-of-use',
    title: 'header.termsOfUse',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Terms of Use`,
    },
  },
  attendanceRules: {
    name: 'Attendance Rules',
    path: '/attendance-term',
    title: 'header.attendanceRules',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Attendance Rules`,
    },
  },
  contactUs: {
    name: 'ContactUs',
    title: 'header.contactUs',
    path: '/contact-us',
    icon: 'mdi-email',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Contact Us`,
    },
  },
  technicalSupport: {
    name: 'TechnicalSupport',
    title: 'header.technicalSupport',

    path: '/technical-support',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Technical Support`,
    },
    icon: 'mdi-face-agent',
  },
  copyRights: {
    name: 'CopyRights',
    title: 'header.copyRights',
    path: '/copy-rights',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Copy Rights`,
    },
  },
  complaints: {
    name: 'Complaints',
    title: 'header.complaints',
    path: '/complaints',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Complaints`,
    },
  },
};
export const guideRoutes = {
  root: {
    name: 'Guide',
    title: 'guide.guide',
    path: '/guide',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Guide`,
    },
  },
  browseACourse: {
    name: 'BrowseACourse',
    title: 'guide.browseACourse',
    path: '/guide/browse-a-course',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Browse A Course`,
    },
  },
  buyACourse: {
    name: 'BuyACourse',
    title: 'guide.buyACourse',
    path: '/guide/buy-a-course',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Buy A Course`,
    },
  },
  login: {
    name: 'Login',
    title: 'guide.login',
    path: '/guide/login',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Login`,
    },
  },
  menu: {
    name: 'Menu',
    title: 'guide.menu',
    path: '/guide/menu',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Menu`,
    },
  },
  progress: {
    name: 'Progress',
    title: 'guide.progress',
    path: '/guide/progress',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Progress`,
    },
  },
};
